import React from "react";
import { Alert, Snackbar } from "@mui/material";

function CustomSnackBar({
  open = false,
  setOpen,
  message = "",
  severity = "info",
  autoHideDuration = 3000,
}) {
  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    if (typeof setOpen === "function") {
      setOpen(false);
    }
  };

  return (
    <Snackbar
      open={Boolean(open)}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert onClose={handleClose} severity={severity} variant="filled" sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
}

export default CustomSnackBar;
